export const FUND_METRIC_CARD_TEXT = {
  /** 도움말 버튼 이름: "<제목> 도움말" */
  helpSuffix: '도움말',
  /** 건수 단위 */
  countUnit: '건',
  grossIrr: 'Gross IRR',
  netIrr: 'Net IRR',
  rvpi: 'RVPI',
  dpi: 'DPI',
} as const;
